import {
  WordSelectionStrategy,
  BackgroundAnimationKind,
} from '@contentlab/types/captions';

export const PERFORMANCE = {
  FPS_LIMIT: 30,
  MAX_CAPTION_LAYOUTS: 200,
} as const;

export const LAYOUT = {
  MAX_TEXT_WIDTH_RATIO: 0.9, // relative to canvas width
  CANVAS_EDGE_PADDING_RATIO: 0.1,
  DEFAULT_LINE_HEIGHT_MULTIPLIER: 1.0,
} as const;

export const TYPOGRAPHY = {
  DEFAULT_FONT_SIZE: 30,
} as const;

export const BACKGROUND = {
  BOX_HEIGHT_TO_FONT_RATIO: 1.4,
  BOX_PADDING_TO_FONT_RATIO: 0.3,
} as const;

export const TEXT_PROCESSING = {
  MIN_CAPTION_DURATION_SECONDS: 1.3,
  LINE_LIMIT: 2,
  CHAR_LIMIT: 46,
  HARD_LINE_LIMIT: 3,
  HARD_CHAR_LIMIT: 80,
} as const;

export const KARAOKE = {
  DEFAULT_WORD_SELECTION_STRATEGY: WordSelectionStrategy.FILL,
  DEFAULT_WORD_COLOR: {
    hex: '#ffff00',
    opacity: 1.0,
  },
  DEFAULT_BACKGROUND_ANIMATION_TYPE: BackgroundAnimationKind.SMOOTH,
  DEFAULT_BACKGROUND: {
    cornerRadius: 8,
    color: {hex: '#000000', opacity: 0.7},
    verticalPadding: 0.2,
    horizontalPadding: 0.3,
  },
} as const;

export function calculateScaleFactor(
  canvasWidth: number,
  canvasHeight: number
): number {
  const baseDimension = 360;
  const scalePower = 4 / 5;
  return (Math.min(canvasWidth, canvasHeight) / baseDimension) ** scalePower;
}
